import { render, staticRenderFns } from "./EmailNotificationForm.vue?vue&type=template&id=31bb546d&scoped=true&"
import script from "./EmailNotificationForm.vue?vue&type=script&lang=js&"
export * from "./EmailNotificationForm.vue?vue&type=script&lang=js&"
import style0 from "./EmailNotificationForm.vue?vue&type=style&index=0&id=31bb546d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31bb546d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
